<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
    }"
  >
    <b-link v-bind="linkProps" class="d-flex align-items-center">
      <span>
        <img
          class="mx-1"
          :src="
            require(`@/assets/images/icons-menu/${
              isActive ? item.iconActive : item.icon
            }`)
          "
          alt="logo"
          style="width: 20px; height: 20px"
        />
      </span>
      <!-- <feather-icon :icon="item.icon || 'CircleIcon'" /> -->
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from "@core/libs/acl";
import { BLink, BBadge } from "bootstrap-vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import useVerticalNavMenuLink from "./useVerticalNavMenuLink";
import mixinVerticalNavMenuLink from "./mixinVerticalNavMenuLink";

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item
    );
    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuLink } = useAclUtils();

    return {
      isActive,
      linkProps,
      updateIsActive,
      // ACL
      canViewVerticalNavMenuLink,
      // i18n
      t,
    };
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/style.scss";

.main-menu.menu-light {
  .navigation > li.active > a {
    background: none !important;
    box-shadow: none;
  }
}
.main-menu.menu-light {
  .navigation > li > a {
    color: $dark-gray-color;
    font-size: 15px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: -0.24px;
  }
}
.main-menu.menu-light {
  .navigation > li.active > a {
    color: $primary-color;
    font-weight: 500;
  }
}
</style>
